<template>
  <AgGridVue
    class="ag-theme-alpine mt-2 saleryOperation"
    style="width: 100%; height: calc(-100px + 100vh)"
    :columnDefs="columnDefs"
    :rowData="rowData"
    :defaultColDef="defaultColDef"
    :gridOptions="gridOptions"
    :getRowId="getRowId"
    rowSelection="multiple"
    :singleClickEdit="true"
    :stopEditingWhenCellsLoseFocus="true"
    :suppressHorizontalScroll="false"
    :domLayout="'normal'"
    :context="{ componentParent: this, currency: this.$store.state.currency.symbol }"
    @grid-ready="onGridReady"
    @selection-changed="onSelectionChanged"
    @row-drag-end="onRowDragEnd"
    :rowHeight="35"
    :overlayLoadingTemplate="`<span class='ag-overlay-loading-center'>${$t(
      'fetching-data'
    )}</span>`"
    :overlayNoRowsTemplate="`<span class='ag-overlay-loading-center'>${$t(
      'no-data-found'
    )}</span>`"
  />
</template>
<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import DenominatorSelectEditor from "../partial/details/DenominatorSelectEditor.vue";
import BasisCalcSelectEditor from "../partial/details/BasisCalcSelectEditor.vue";
import AgMoney from "@/views/dashboard/components/general/AgGridComponents/Ag-money.vue";
import AgVMenu from "@/views/dashboard/components/general/AgGridComponents/Ag-vmenu.vue";
const SUB_FIELDS = [
  { key: "day", title: "روز" },
  { key: "hour", title: "ساعت" },
  { key: "min", title: "دقیقه" },
  { key: "percent", title: "درصد" },
  { key: "amount", title: "ریال" },
];
export default {
  name: "SalaryOperationMock",
  props: {
    saveReturn: {
      type: Boolean,
      default: false,
    },
    saleryOperationsOptions: {
      type: [String, Object, Array],
      default: [],
    },
    loading: Boolean,
  },
  components: {
    AgGridVue: Vue.extend(AgGridVue),
    AgMoney: Vue.extend(AgMoney),
    DenominatorSelectEditor: Vue.extend(DenominatorSelectEditor),
    BasisCalcSelectEditor: Vue.extend(BasisCalcSelectEditor),
    AgVMenu: Vue.extend(AgVMenu),
  },
  data() {
    return {
      moneyColumns: ["defaultAmount"],
      smallNumberMaxWidth: 60,
      tableOptions: {
        itemsPerPage: 1000,
      },
      factors: [],
      deletedRows: [],
      rowInstancesById: {},
      // neme_parameter: "",
      workshopID: null,
      gridApi: null,
      gridColumnApi: null,
      selectedRowData: null,
      selectedRowIndex: null,
      defaultColDef: {
        resizable: true,
        sortable: false,
      },
      totals: { debtor: 0, creditor: 0 },
      gridOptions: {
        enableRtl: true,
        context: { componentParent: this },
        onCellValueChanged: (params) => {
          const vm = params.context.componentParent;
          const { data: row, colDef, oldValue, newValue } = params;
          if (oldValue === newValue) return;
          vm.rowInstancesById[row.id] = vm.buildRowInstance(row, params.node.rowIndex);
          vm.$emit("table-changing", Object.values(vm.rowInstancesById));
        },
        rowSelection: "multiple",
        rowDragManaged: true,
        suppressKeyboardEvent: (params) => {
          const key = params.event.key;
          const editingCells = params.api?.getEditingCells?.() || [];
          const isEditingAutoComplete = editingCells.some(
            (cell) =>
              cell.rowIndex === params.node?.rowIndex &&
              cell.column.getColId() === "given"
          );

          if (isEditingAutoComplete) {
            if (["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(key)) {
              return true;
            }
          }
          const isEditingDenominatorType = editingCells.some(
            (cell) =>
              cell.rowIndex === params.node?.rowIndex &&
              cell.column.getColId() === "denominatorType"
          );
          if (isEditingDenominatorType) {
            if (["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(key)) {
              return true;
            }
          }
          const isEditingBasisOfCalc = editingCells.some(
            (cell) =>
              cell.rowIndex === params.node?.rowIndex &&
              cell.column.getColId() === "basisOfCalc"
          );
          if (isEditingBasisOfCalc) {
            if (["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(key)) {
              return true;
            }
          }
          return false;
        },
        suppressHorizontalScroll: true,
        rowHoverHighlight: false,
      },
      contractFactors: [
        { id: 1, field: "applicableInsurance" },
        { id: 2, field: "applicableTax" },
      ],
      effectiveWorksMock: [],
      InsuranceTaxes: [],
      Other: [
        {
          field: "fixedCoefficient",
          type: "number",
        },
        {
          field: "fixedNumber",
          type: "number",
        },
      ],
      columnDefs: [],
      rowData: [],
      qID: null,
    };
  },
  created() {
    this.buildColumnDefs();
    const query = this.$route.query || {};
    if (Object.keys(query).length > 0) {
      this.$emit("appBarObject", query);
      this.$emit("isDisabled", true);
    } else {
      this.$emit("isDisabled", false);
    }
  },
  mounted() {
    document.addEventListener("keydown", this.globalKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.globalKeyDown);
  },
  watch: {
    rowData: {
      deep: true,
      handler(newVal) {
        this.$nextTick(() => {
          this.adjustColumnWidth("defaultAmount");
          this.effectiveWorksMock.forEach((item) => {
            this.adjustColumnWidth(item.field);
          });
        });
      },
    },
    saveReturn: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.buildSaleryFactors();
          this.$emit("again-ready-to-save");
        }
      },
    },
    saleryOperationsOptions: {
      deep: true,
      handler(newVal) {
        this.workshopID = newVal.workshop_id;
        if (this.gridApi && this.workshopID) {
          this.fetchData();
        }
      },
    },
  },
  methods: {
    globalKeyDown(event) {
      const api = this.gridApi;
      if (!api) return;
      if (api.getEditingCells?.().length) return;
      if (!["ArrowUp", "ArrowDown"].includes(event.key)) {
        return;
      }
      event.preventDefault();
      const focused = api.getFocusedCell();
      if (!focused) {
        const firstCol = api.getAllDisplayedColumns()[0];
        if (!firstCol) return;
        api.setFocusedCell(0, firstCol.getColId());
        api.getDisplayedRowAtIndex(0)?.setSelected(true);
        return;
      }
      const direction = event.key === "ArrowDown" ? 1 : -1;
      this.navigateRow(api, direction);
    },
    navigateRow(api, direction) {
      const selectedNodes = api.getSelectedNodes();
      const totalRows = api.getDisplayedRowCount();
      let nextIndex = 0;
      let currentColumn = api.getFocusedCell()?.column?.getColId();
      if (selectedNodes.length) {
        const currentIndex = selectedNodes[0].rowIndex;
        const currentColumnIndex = api.getFocusedCell()?.column?.getColId();
        currentColumn = currentColumnIndex;
        nextIndex = currentIndex + direction;
      }
      if (nextIndex < 0) nextIndex = 0;
      if (nextIndex >= totalRows) nextIndex = totalRows - 1;
      api.forEachNode((node) => node.setSelected(false));
      const targetNode = api.getDisplayedRowAtIndex(nextIndex);
      if (targetNode) {
        targetNode.setSelected(true);
        api.ensureIndexVisible(nextIndex);
        api.setFocusedCell(nextIndex, currentColumn);
      }
    },
    setInitialFocus() {
      const api = this.gridApi;
      if (!api || api.getDisplayedRowCount() === 0) return;
      const firstCol = api.getAllDisplayedColumns()[0];
      if (!firstCol) return;
      api.setFocusedCell(0, firstCol.getColId());
      api.getDisplayedRowAtIndex(0)?.setSelected(true);
    },
    adjustColumnWidth(colId, maxWidth = 150, minWidth = 25) {
      if (!this.gridApi || !this.gridColumnApi) return;
      let maxLength = 0;
      let hasLargeValue = false;
      const [field, subKey] = colId.split("_");
      this.gridApi.forEachNodeAfterFilterAndSort((node) => {
        const value = node.data?.[field]?.[subKey];
        if (value == null) return;
        if (Math.abs(value) > 9999) {
          hasLargeValue = true;
        }
        const text = new Intl.NumberFormat().format(value);
        maxLength = Math.max(maxLength, text.length);
      });
      if (maxLength === 0) {
        this.gridColumnApi.setColumnWidth(colId, minWidth);
        return;
      }
      let calculatedWidth;
      if (!this.moneyColumns.includes(colId) && !hasLargeValue) {
        calculatedWidth = maxLength * 6 + 15;
        calculatedWidth = Math.min(calculatedWidth, this.smallNumberMaxWidth);
      } else {
        calculatedWidth = maxLength * 8 + 30;
      }
      const finalWidth = Math.min(maxWidth, Math.max(minWidth, calculatedWidth));
      this.gridColumnApi.setColumnWidth(colId, finalWidth);
    },
    adjustAllNumberColumns() {
      if (!this.gridApi) return;
      const colIds = [];
      this.effectiveWorksMock.forEach((item) => {
        SUB_FIELDS.forEach((sf) => {
          colIds.push(`${item.field}_${sf.key}`);
        });
      });

      this.InsuranceTaxes.forEach((item) => {
        SUB_FIELDS.forEach((sf) => {
          colIds.push(`${item.field}_${sf.key}`);
        });
      });

      colIds.forEach((colId) => {
        this.adjustColumnWidth(colId);
      });
    },
    parseFactorValue(value) {
      try {
        return typeof value === "string" ? JSON.parse(value) : value || {};
      } catch {
        return {};
      }
    },
    buildColumnDefs() {
      const effectiveWorksGroups = this.effectiveWorksMock.map((item) => ({
        headerName: item.title,
        editable: true,
        resizable: false,
        marryChildren: true,
        headerClass: ["vertical-header", "effective-works-group"],
        children: SUB_FIELDS.filter((sf) =>
          this.rowData.some((r) => r[item.field]?.[sf.key] !== undefined)
        ).map((sf) =>
          this.makeNumberSubCol({
            field: item.field,
            key: sf.key,
            header: sf.title,
            headerClass: ["vertical-header", "effective-works-group"],
          })
        ),
      }));
      const insuranceTaxesGroups = this.InsuranceTaxes.map((item) => ({
        headerName: item.title,
        editable: true,
        resizable: false,
        marryChildren: true,
        headerClass: ["vertical-header", "effective-works-group"],
        children: SUB_FIELDS.filter((sf) =>
          this.rowData.some((r) => r[item.field]?.[sf.key] !== undefined)
        ).map((sf) =>
          this.makeNumberSubCol({
            field: item.field,
            key: sf.key,
            header: sf.title,
            headerClass: ["vertical-header", "effective-works-group"],
          })
        ),
      }));
      const baseColumns = [
        {
          headerName: "",
          width: 50,
          maxWidth: 50,
          minWidth: 50,
          cellRenderer: "AgVMenu",
          cellRendererParams: (params) => ({
            items: [
              {
                label: this.$t("calc_"),
                icon: "mdi-alert-circle",
                iconColor: "gray",
                action: (rowData) => this.openDialog(rowData),
              },
              {
                label: this.$t("delete"),
                icon: "mdi-trash-can-outline",
                iconColor: "gray",
                action: (rowData) => this.deleteAction(rowData),
              },
            ],
          }),
          resizable: false,
          pinned: "right",
          headerClass: ["vertical-header"],
        },
        {
          headerName: this.$t("#"),
          field: "rowNumber",
          valueGetter: (params) => params.node.rowIndex + 1,
          width: 35,
          maxWidth: 35,
          minWidth: 35,
          resizable: false,
          pinned: "right",
          headerClass: ["vertical-header"],
        },
        {
          headerName: this.$t("personel"),
          field: "name",
          width: 130,
          maxWidth: 130,
          minWidth: 130,
          resizable: false,
          pinned: "right",
          headerClass: ["vertical-header"],
          valueFormatter: (params) => {
            if (!params.value) return "";
            const text = this.$t(params.value);
            return text.length > 12 ? text.substring(0, 12) + "..." : text;
          },
        },
      ];
      this.columnDefs = [
        ...baseColumns,
        ...effectiveWorksGroups,
        ...insuranceTaxesGroups,
      ];
    },
    makeNumberSubCol({ field, key, header }) {
      const colId = `${field}_${key}`;
      return {
        colId,
        headerName: header,
        editable: true,
        width: 40,
        minWidth: 35,
        resizable: false,
        headerClass: "horizental-header",
        cellEditor: "agNumberCellEditor",
        valueGetter: (params) => {
          return params.data?.[field]?.[key] ?? 0;
        },
        valueFormatter: (params) => {
          if (params.value == null) return "";
          return new Intl.NumberFormat("fa-IR").format(params.value);
        },
        valueSetter: (params) => {
          if (!params.data[field]) params.data[field] = {};
          params.data[field][key] = Number(params.newValue) || 0;
          this.adjustColumnWidth(colId);
          return true;
        },
      };
    },
    getRowId(params) {
      return params.data.id;
    },
    async fetchData() {
      var app = this;
      if (this.gridApi) {
        this.gridApi.showLoadingOverlay();
      }
      const id_ = app.$route.query.id ? app.$route.query.id : 0;
      const workshopId = this.workshopID || app.$route.query.hrm_workshop_id;
      app.$axios
        .get(app.$endpoint + "salary/" + id_, {
          params: {
            workshop: workshopId,
          },
        })
        .then((res) => {
          let mapingChenged = res.data.configs;
          mapingChenged.forEach((row) => {
            if (row.changed == true) {
              row.changed = false;
            }
          });
          const configs = res.data.configs;
          const factors = res.data.salary_factors;
          this.factors = Array.isArray(factors) ? factors : [];
          if (!Array.isArray(configs) || !Array.isArray(factors)) {
            this.rowData = [];
            this.InsuranceTaxes = [];
            this.effectiveWorksMock = [];
            return;
          }
          const factorArray = new Map(factors.map((f) => [String(f.id), f]));
          const fieldSet = new Set();
          configs.forEach((config) => {
            Object.keys(config).forEach((key) => {
              if (/^\d+$/.test(key) && factorArray.has(key)) {
                fieldSet.add(key);
              }
            });
          });
          this.InsuranceTaxes = [];
          this.effectiveWorksMock = [];
          fieldSet.forEach((field) => {
            const factor = factorArray.get(field);
            if (factor.function_type != null) {
              this.effectiveWorksMock.push({
                id: Number(field),
                title: factor.name,
                field: field,
                value: Number(factor.value) || 0,
              });
            } else if (factor.function_type == null) {
              this.InsuranceTaxes.push({
                id: Number(field),
                title: factor.name,
                field: field,
                value: Number(factor.value) || 0,
              });
            }
          });
          const rows = [];
          configs.forEach((config) => {
            const row = {
              id: config.id,
              name: config.name,
            };
            this.effectiveWorksMock.forEach((factor) => {
              const factorId = factor.field;

              if (config[factorId]) {
                row[factorId] = {
                  ...config[factorId],
                };
              }
            });
            this.InsuranceTaxes.forEach((factor) => {
              const factorId = factor.field;
              if (config[factorId]) {
                row[factorId] = { ...config[factorId] };
              }
            });
            rows.push(row);
          });
          this.rowData = rows;
          this.buildColumnDefs();
          this.$nextTick(() => {
            this.gridApi?.setColumnDefs(this.columnDefs);
            this.adjustAllNumberColumns();
            this.adjustColumnWidth();
            this.gridApi?.hideOverlay();
          });
        })
        .catch((err) => {
          app.$emit("show-error", err?.response?.data?.message);
        })
        .finally(() => {
          this.$emit("");
        });
    },
    NumberArray(data) {
      if (!Array.isArray(data) || !data.length) return [];
      const numberFields = new Set();
      data.forEach((row) => {
        Object.keys(row).forEach((key) => {
          const value = row[key];
          if (typeof value === "number" && !isNaN(value)) {
            numberFields.add(key);
          }
        });
      });
      return Array.from(numberFields);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.fetchData();
      this.setInitialFocus();
    },
    buildRowInstance(row, rowIndex) {
      return {
        row_id: row.id,
        row_index: rowIndex,
        name: row.name,
        instanceeffectiveWorksMock: this.effectiveWorksMock
          .map((f) => ({
            factor_id: f.id,
            title: f.title,
            value: Number(row[f.field]) || 0,
          }))
          .filter((f) => f.value > 0),

        instanceInsuranceTaxes: this.InsuranceTaxes.map((f) => ({
          factor_id: f.id,
          title: f.title,
          value: Boolean(row[f.field]),
        })).filter((f) => f.value === true),
      };
    },
    onSelectionChanged() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      if (!selectedNodes.length) return;
      const lastNode = selectedNodes[selectedNodes.length - 1];
      const row = lastNode.data;
      this.rowInstancesById = {};
      this.rowInstancesById[row.id] = this.buildRowInstance(row, lastNode.rowIndex);
      this.$emit("table-changing", [this.rowInstancesById[row.id]]);
    },
    onRowDragEnd() {
      const updated = [];
      this.gridApi.forEachNode((node) => updated.push(node.data));
      this.rowData = updated;
    },
    deleteAction(row) {
      if (!row) return;
      this.gridApi.applyTransaction({ remove: [row] });
      this.rowData = this.rowData.filter((r) => r.id !== row.id);
    },
    openDialog(rowData) {
      const options = this.saleryOperationsOptions || {};
      const year = options.year;
      const month = options.month;
      const hasYear = year != null && String(year).trim() !== "";
      const hasMonth = month != null && String(month).trim() !== "";
      this.$emit("open-calc-dialog", {
        configs: rowData,
        ...(hasYear ? { year } : {}),
        ...(hasMonth ? { month } : {}),
      });
    },
    isSaleryOperationsOptionsInvalid(options) {
      if (options == null) return true;
      if (Array.isArray(options) && options.length === 0) return true;
      if (typeof options !== "object") return true;
      const w = options.workshop_id;
      const wid =
        w != null && typeof w === "object" && !Array.isArray(w) && "id" in w ? w.id : w;
      const noWorkshop = wid == null || wid === "";
      const year = options.year;
      const month = options.month;
      const noYear = year == null || year === "" || String(year).trim() === "";
      const noMonth = month == null || month === "" || String(month).trim() === "";
      return noWorkshop || noYear || noMonth;
    },
    buildSaleryFactors() {
      var app = this;
      let data = app.rowData;
      let options = app.saleryOperationsOptions;
      if (app.isSaleryOperationsOptionsInvalid(options)) {
        app.$emit("validation", false);
        return;
      }
      const invalidRows = this.rowData.filter((row) =>
        this.effectiveWorksMock.every((cf) => row[cf.field] > 0)
      );
      if (invalidRows.length == app.rowData.length) {
        this.$emit("at-least-one-required");
        this.$emit("again-ready-to-save");
        return;
      }
      const id_ = app.$route.query.id ? app.$route.query.id : 0;
      if (id_ == 0) {
        app.$axios
          .post(this.$endpoint + "salary", {
            configs: data,
            workshop: options.workshop_id,
            year: options.year,
            month: options.month,
          })
          .then((response) => {
            this.qID = response.data.id;
            this.$router.push({
              name: "salery_operations_list",
              query: {
                id: this.qID,
              },
            });
          })
          .catch((err) => {
            app.$emit("again-ready-to-save");
            app.$emit("show-error", err?.response?.data?.message);
          })
          .finally(() => {
            app.$emit("again-ready-to-save");
          });
      } else {
        app.$axios
          .put(this.$endpoint + "salary/" + id_, {
            configs: data,
            workshop: options.workshop_id,
            year: options.year,
            month: options.month,
          })
          .then((response) => {
            this.qID = response.data.id;
            this.$router.push({
              name: "salery_operations_list",
              query: {
                id: this.qID,
              },
            });
          })
          .catch((err) => {
            app.$emit("again-ready-to-save");
            app.$emit("show-error", err?.response?.data?.message);
          })
          .finally(() => {
            app.$emit("again-ready-to-save");
          });
      }
    },
  },
};
</script>
<style>
.ag-theme-alpine.saleryOperation .ag-header-row.ag-header-row-column {
  height: 100% !important;
}
.ag-theme-alpine.saleryOperation .ag-header-row.ag-header-row-column .ag-header-cell {
  height: 35px !important;
  min-height: 30px !important;
}
.ag-theme-alpine.saleryOperation
  .ag-header-row.ag-header-row-column
  .ag-header-cell.vertical-header {
  height: 135px !important;
  min-height: 95px !important;
}

.ag-theme-alpine.saleryOperation .ag-header {
  height: auto !important;
  min-height: 145px !important;
}
.vertical-header .ag-header-cell-label {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  justify-content: center;
  align-items: center;
  height: 135px;
  padding: 0px;
  white-space: nowrap;
}
.ag-theme-alpine.saleryOperation .ag-header-group-cell-label.ag-sticky-label {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  justify-content: center;
  align-items: center;
  padding: 0px;
  white-space: nowrap;
}
.ag-theme-alpine.saleryOperation
  .ag-header-row.ag-header-row-column-group
  .ag-header-group-cell.effective-works-group {
  height: 115px !important;
  padding-top: 5px;
}
.ag-theme-alpine.saleryOperation .ag-header-row.ag-header-row-column {
  top: 115px !important;
}
.ag-theme-alpine.saleryOperation
  .ag-header
  .ag-pinned-right-header
  .ag-header-row.ag-header-row-column-group {
}
.ag-theme-alpine.saleryOperation
  .ag-header
  .ag-pinned-right-header
  .ag-header-row.ag-header-row-column {
  top: 58px !important;
}
.horizental-header .ag-cell-label-container {
  display: block !important;
  overflow: visible !important;
}
.horizental-header .ag-header-cell-label {
  overflow: visible;
  text-overflow: unset;
  display: block;
}
.horizental-header .ag-header-cell-text {
  overflow: visible;
  text-overflow: unset;
  display: block;
  white-space: normal !important;
  text-align: center;
}

@media (max-width: 768px) {
  table.visual td {
    width: 100%;
    display: block;
    box-sizing: border-box;
  }
  table.visual {
    width: 100%;
    table-layout: auto;
  }
}
@media (max-width: 480px) {
  table.visual .column-width {
    width: 100%;
  }
  table.visual .column-width-small {
    width: 100%;
  }
}
.ag-theme-alpine.saleryOperation .ag-body-horizontal-scroll {
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
}
.ag-theme-alpine.saleryOperation .ag-body-horizontal-scroll ::-webkit-scrollbar {
  height: 8px;
}
.ag-theme-alpine.saleryOperation .ag-body-horizontal-scroll ::-webkit-scrollbar-track {
  background: #f1f0f0;
  border-radius: 6px;
}
.ag-theme-alpine.saleryOperation .ag-body-horizontal-scroll ::-webkit-scrollbar-thumb {
  background: #bdbdbdd2;
  border-radius: 6px;
}
.ag-theme-alpine.saleryOperation
  .ag-body-horizontal-scroll
  ::-webkit-scrollbar-thumb:hover {
  background: #9e9e9ecf;
}
.v-data-table__wrapper {
  min-height: 0;
  height: 100%;
}
.invalid-cell {
  background-color: rgba(255, 102, 102, 0.4) !important;
  transition: background-color 0.3s ease;
}
.ag-input-field-input.ag-checkbox-input {
  cursor: pointer;
}
.ag-theme-alpine.saleryOperation .ag-header-cell,
.ag-theme-alpine.saleryOperation .ag-header-group-cell {
  padding: 0px;
  border-left: 1px solid #cfcfcf;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ag-theme-alpine.saleryOperation .ag-header-group-text {
  font-weight: bold;
  font-size: 12px;
  padding: 2px 0;
}

.ag-theme-alpine.saleryOperation.ag-rtl .ag-cell-wrapper {
  flex-direction: row-reverse;
}
.ag-wrapper.ag-input-wrapper.ag-checkbox-input-wrapper.ag-checked {
  background-color: transparent;
}
.ag-theme-alpine.saleryOperation .ag-checkbox-input-wrapper {
  font-size: 13px !important;
}
.ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell.ag-focus-managed:nth-child(1),
.ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell.ag-focus-managed:nth-child(3) {
  overflow: visible;
}
.ag-theme-alpine.saleryOperation
  .ag-pinned-right-cols-container
  .ag-row
  .ag-cell:nth-child(2) {
  text-align: center;
}
.ag-theme-alpine.saleryOperation
  .ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell:nth-child(1) {
  border-right: none;
  border-top: none;
}
.ag-theme-alpine.saleryOperation
  .ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell {
  border-right: none;
  border-top: none;
}
.ag-theme-alpine.saleryOperation .ag-row {
  border-bottom: 1px solid #d3d3d3;
}
.ag-theme-alpine.saleryOperation .ag-cell {
  border-left: 1px solid #d3d3d3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  padding: 0px !important;
}
.ag-theme-alpine.saleryOperation .ag-cell-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}
.ag-theme-alpine.saleryOperation .ag-cell-wrapper.ag-cell-edit-wrapper.ag-checkbox-edit {
  padding: 0px !important;
}
.ag-theme-alpine.saleryOperation .ag-cell-inline-editing {
  height: 33px !important;
}
.ag-theme-alpine.saleryOperation .ag-checkbox.ag-disabled {
  display: none !important;
}
.ag-theme-alpine.saleryOperation .ag-header-cell {
  border-left: 1px solid #cfcfcf;
}
.ag-theme-alpine.saleryOperation .ag-cell.ag-column-first {
  border-right: none;
  padding: 0;
}
.ag-theme-alpine.saleryOperation .ag-rtl .ag-header-select-all,
.ag-theme-alpine.saleryOperation .ag-rtl .ag-selection-checkbox {
  margin-left: 0;
}
.ag-theme-alpine.saleryOperation .ag-rtl .ag-row-drag {
  margin-left: 2px;
}
.ag-header-cell.ag-column-first .ag-header-cell-comp-wrapper {
  width: auto !important;
}
.ag-theme-alpine.saleryOperation
  .ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell:nth-child(2)
  .ag-header-cell-label {
  justify-content: center;
}
.ag-theme-alpine.saleryOperation .ag-checkbox-input-wrapper {
  width: 12px;
  height: 12px;
  margin-bottom: 5px !important;
}
.ag-theme-alpine.saleryOperation .ag-checkbox-input-wrapper:focus-within {
  box-shadow: none;
}
.ag-theme-alpine.saleryOperation .ag-row-selected,
.ag-row-selected::before {
  background-color: rgb(169 217 255 / 12%);
}
.ag-theme-alpine .ag-row-hover,
.ag-theme-alpine .ag-row-hover::after,
.ag-theme-alpine .ag-row-hover::before {
  background-color: rgb(169 217 255 / 12%) !important;
}
.ag-row-hover.ag-row-selected::before {
  background-image: none !important;
}
.ag-theme-alpine.saleryOperation .ag-cell-value.ag-cell.ag-cell-data-changed {
  background-color: rgb(255 102 102 / 41%) !important;
}
.bgColor-insurance {
  background-color: #f2f9ff !important;
}
.headerName-insurance {
  background-color: #f2f9ff !important;
}
.bgColor-contract {
  background-color: #fff4dc !important;
}
.headerName-contract {
  background-color: #fff4dc !important;
}
.bgColor-other {
  background-color: #efe3fb !important;
}
.headerName-others {
  background-color: #efe3fb !important;
}
.bgColor-effectiveWorks {
  background-color: #fcfff0 !important;
}
.bgColor-effectiveWorks-related {
  background-color: #fcfff0 !important;
}
/* hover */
.ag-row-hover .bgColor-insurance {
  background-color: #e3f2ff !important;
}
.ag-row-hover .bgColor-contract {
  background-color: #ffe9b3 !important;
}
.ag-row-hover .bgColor-other {
  background-color: #e6d6fa !important;
}
.ag-row-hover .bgColor-effectiveWorks,
.ag-row-hover .bgColor-effectiveWorks-related {
  background-color: #f3f7dc !important;
}
/* selected */
.ag-row-selected .bgColor-insurance {
  background-color: #e3f2ff !important;
}

.ag-row-selected .bgColor-contract {
  background-color: #ffe9b3 !important;
}

.ag-row-selected .bgColor-other {
  background-color: #e6d6fa !important;
}

.ag-row-selected .bgColor-effectiveWorks,
.ag-row-selected .bgColor-effectiveWorks-related {
  background-color: #f3f7dc !important;
}
.denominator-cell {
  padding: 4px !important;
}

.denominator-select-btn {
  height: 22px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  cursor: pointer;
  font-size: 12px;
}
.denominator-select-btn {
  width: 80px;
}
.basis-select-btn {
  width: 73px;
}

.denominator-select-btn .text {
  color: #444;
  white-space: nowrap;
}

.denominator-select-btn .icon {
  font-size: 18px;
  color: #666;
}

.ag-row-hover .denominator-select-btn {
  border-color: #b5b5b5;
}
</style>
